import { UseJobList } from 'cms/features/feature_job/hooks';
import React from 'react';
import { Link } from 'react-router-dom';
import {
    Box,
    Typography,
    Chip,
    Stack,
    CircularProgress,
    Button
} from '@mui/material';
import ModernJobCard from './ModernJobCard';

function RecentJobslist() {
    const { data, isLoading, isError } = UseJobList({ size: 6, filters: { archived: '0' } });
    const jobs = data?.results || [];
    const jobsCount = jobs.length;

    return (
        <Box sx={{ mt: 4 }}>
            <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
                <Typography variant="h6" fontWeight={600}>
                    Recent jobs
                </Typography>
                {jobsCount > 0 && (
                    <Chip 
                        label={jobsCount} 
                        size="small" 
                        color="primary" 
                        variant="outlined"
                    />
                )}
            </Stack>
            
            {isLoading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            )}
            
            {!isLoading && isError && (
                <Box sx={{ py: 4, textAlign: 'center' }}>
                    <Typography variant="body1" color="text.secondary">
                        Error loading recent jobs.
                    </Typography>
                </Box>
            )}
            
            {!isLoading && !isError && jobs.length === 0 && (
                <Box sx={{ py: 4, textAlign: 'center' }}>
                    <Typography variant="body1" color="text.secondary">
                        No recent jobs available.
                    </Typography>
                </Box>
            )}
            
            {!isLoading && !isError && jobs.length > 0 && (
                <Box>
                    {jobs.map((job) => (
                        <ModernJobCard key={job.id} job={job} />
                    ))}
                    
                    <Box sx={{ mt: 3, textAlign: 'center' }}>
                        <Button
                            component={Link}
                            to="/jobs"
                            variant="outlined"
                            color="primary"
                        >
                            Explore more
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    );
}

export default RecentJobslist;